import { render, staticRenderFns } from "./BenchmarkSelectWrapper.vue?vue&type=template&id=e8f34968&"
import script from "./BenchmarkSelectWrapper.vue?vue&type=script&lang=js&"
export * from "./BenchmarkSelectWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports